module.exports = "//static.hsappstatic.net/HubspotToolsMenu/static-1.143/js/sprocket_orange.svg"